module.exports = __webpack_public_path__ + "static/media/down-arrow-svgrepo-com (1).e6fc278a.svg";